import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isCollapsed: false,
  isHydrated: false,
  isMobileSidebarOpen: false,
};

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setIsCollapsed: (state, action) => {
      state.isCollapsed = action.payload;
    },
    toggleCollapsed: (state) => {
      state.isCollapsed = !state.isCollapsed;
    },
    setIsHydrated: (state, action) => {
      state.isHydrated = action.payload;
    },
    setIsMobileSidebarOpen: (state, action) => {
      state.isMobileSidebarOpen = action.payload;
    },
    toggleMobileSidebarOpen: (state) => {
      state.isMobileSidebarOpen = !state.isMobileSidebarOpen;
    },
    resetSidebar: (state) => {
      state.isCollapsed = false;
      state.isMobileSidebarOpen = false;
    },
  },
});

export const {
  setIsCollapsed,
  toggleCollapsed,
  setIsHydrated,
  setIsMobileSidebarOpen,
  toggleMobileSidebarOpen,
  resetSidebar,
} = sidebarSlice.actions;

export default sidebarSlice.reducer;

